module.exports = __webpack_public_path__ + "img/w3_button_check_black.202cc6d9.png";